import React, { useContext, useState, useEffect } from 'react';
import icon from '../imgs/Icon_nobg.svg';
import { Link } from 'react-router-dom';
import enFlag from '../imgs/english-flag.png';
import arFlag from '../imgs/arabic-flag.png';
import { FaBars } from 'react-icons/fa6';
import { FaXmark } from 'react-icons/fa6';
import { api } from '../api';
import '../css/header.css'


const Header = () => {
  const { t, changeLanguage, language, } = useContext(api)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    
    console.log(isMobileMenuOpen)
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  return (
    <>
      {isMobile ? (
        <header className="header">
          <Link to="/">
            <img src={icon} alt="United Group Icon" className="LogoIcon" />
          </Link>
          <div className='MobileDropDownMenu' onClick={handleMobileMenuToggle}>
            {isMobileMenuOpen ? (
              <FaXmark style={{ color: "white", cursor: "pointer", scale: "1.25" }} />
            ) : (
              <FaBars style={{ color: "white", cursor: "pointer" }} />
            )}
          </div>
          {/* Dropdown Menu */}
          <nav className={isMobileMenuOpen ? "MobileMenu MobileMenuActive" : "MobileMenu"} onClick={() => {handleMobileMenuToggle()}}>
            <ul>
              <li><Link to="/about-us">{t('aboutUs')}</Link></li>
              <li><Link to="/contact-us">{t('contactUs')}</Link></li>
            </ul>
            <div className="language-selector">
              <img
                src={enFlag}
                alt="English Flag"
                onClick={() => changeLanguage('en')}
                className={language === 'en' ? 'active' : ''}
              />
              <img
                src={arFlag}
                alt="Arabic Flag"
                onClick={() => changeLanguage('ar')}
                className={language === 'ar' ? 'active' : ''}
              />
            </div>
          </nav>
        </header>
      ) : (
        <header className="header">
          <Link to="/">
            <img src={icon} alt="United Group Icon" className="LogoIcon" />
          </Link>
          <nav>
            <ul>
              <li><Link to="/about-us">{t('aboutUs')}</Link></li>
              <li><Link to="/contact-us">{t('contactUs')}</Link></li>
            </ul>
            <div className="language-selector">
              <img
                src={enFlag}
                alt="English Flag"
                onClick={() => changeLanguage('en')}
                className={language === 'en' ? 'active' : ''}
              />
              <img
                src={arFlag}
                alt="Arabic Flag"
                onClick={() => changeLanguage('ar')}
                className={language === 'ar' ? 'active' : ''}
              />
            </div>
          </nav>
        </header>
      )}
    </>
  );
}

export default Header;